import { useQuery } from '@abyss/web/hooks/useQuery';
// @ts-ignore
import { ApiUrl } from '@src/common/ajax/apiUrl';
import UpdateProvider from './UpdateProvider.gql';

export const useUpdateProvider = (options) => {
  return useQuery(UpdateProvider, {
    ...options,
    url: ApiUrl.graphQl(),
  });
};
